import React from "react";
import { useTranslation } from "react-i18next";

/** US-404: short trust signals for landing + app footer. */
export function TrustStrip({ className }: { className?: string }) {
  const { t } = useTranslation();
  const items = [
    t("investor.trust.eudr"),
    t("investor.trust.audit"),
    t("investor.trust.providers"),
  ];

  return (
    <div className={className} data-testid="trust-strip" role="contentinfo">
      <ul className="trust-strip__list">
        {items.map((label) => (
          <li key={label} className="trust-strip__item">
            {label}
          </li>
        ))}
      </ul>
      <p className="trust-strip__note">{t("investor.trust.note")}</p>
    </div>
  );
}
